import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// firebase/firestore configuration & imports
import { environment } from '../environments/environment.prod';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
 
import { AppComponent } from './app.component';
import { CustomersComponent } from './components/customers/customers.component';

import { CustomerService } from './services/customer.service';
import { AddCustomerComponent } from './components/add-customer/add-customer.component';


@NgModule({
  declarations: [
    AppComponent,
    CustomersComponent,
    AddCustomerComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    // firebase imports
    AngularFireModule.initializeApp(environment.firebase, 'angularfs'),
    AngularFirestoreModule
  ],
  providers: [
    CustomerService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts